import AuthPage from "../auth/AuthPage";

export default AuthPage;
